import React, { useEffect, useState } from "react";
import { Container, Grid } from "@material-ui/core";
import ShareUser from "../ShareUser";
import { NavLink } from "react-router-dom";
import axios from "axios";
import ShareTable from "./ShareTable";
import Constants from "../../App/Variables/Constants";

const btnStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: 10,
  background: "#E3E3E3",
  border: 0,
  outline: 0,
  height: 88,
  width: 292,
  color: "#666666",
  fontSize: 18,
  fontWeight: 600,
  paddingLeft: 20,
  paddingRight: 20,
  textDecoration: "none",
};

const ShareListing = ({ userId }) => {
  const [my_shares, set_my_shares] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const get_shares = async () => {
    try {
      const { data } = await axios.get(
        `${Constants.getUrls.getShareProducts}/myshares?user=${userId}&limit=${rowsPerPage}&page=${page}`
      );
      set_my_shares(data.shareProduct.docs);
      setCount(data.shareProduct.totalPages);
      setPage(data.shareProduct.page);
      setRowsPerPage(data.shareProduct.limit);
    } catch (err) { }
  };
  useEffect(() => {
    (async () => {
      await get_shares();
    })();
  }, [page]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }
  return (
    <Container className="containerSpacingdashBoard" maxWidth={'lg'}>
      <Grid
        container
        spacing={2}
        className="userDashboard"
      >
        <Grid item sm={12} style={{ border: "0px solid red", padding: "0 64px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: 15,
              paddingBottom: 50,
              borderBottom: "1px solid #ddd",
            }}
          >
            <ShareUser btnStyle={btnStyle} user_id={userId} />

            <div style={{ width: 20 }} />
            <NavLink
              to={"/admin/share/" + userId}
              style={{
                textDecoration: "none",
              }}
              target="_blank"
            >
              <button style={btnStyle}>Create Webpage</button>
            </NavLink>
          </div>
          <div
            style={{
            }}
          >
            <div
              style={{
                fontSize: 20,
                fontWeight: 400,
                color: "#2e2e2e",
                padding: "0 0 28px",
                marginTop: 34
                // marginBottom: 15,
              }}
            >
              All Product Links
            </div>
            <ShareTable shares={my_shares} get_shares={get_shares} onChangePage={handleChangePage} page={page} count={count} user_id={userId} />
          </div>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ShareListing;
